import {
  FOOTER_REQUEST,
  FOOTER_SUCCESS,
  FOOTER_FAILURE,
  FOOTER_DETAILS_PAGE_REQUEST,
  FOOTER_DETAILS_PAGE_SUCCESS,
  FOOTER_DETAILS_PAGE_FAILURE
} from '../constants'
import { fetchFooterDetails, fetchFooterPageDetails } from 'api'

export const getFooterDetails = () => async (dispatch) => {
  try {
    dispatch({ type: FOOTER_REQUEST })

    const { data } = await fetchFooterDetails()

    dispatch({
      type: FOOTER_SUCCESS,
      payload: data
    })
  } catch {
    dispatch({
      type: FOOTER_FAILURE,
      payload: 'error'
    })
  }
}

export const getFooterPageDetails = (id) => async (dispatch) => {
  try {
    dispatch({ type: FOOTER_DETAILS_PAGE_REQUEST })

    const { data } = await fetchFooterPageDetails(id)

    dispatch({
      type: FOOTER_DETAILS_PAGE_SUCCESS,
      payload: data
    })
  } catch {
    dispatch({
      type: FOOTER_DETAILS_PAGE_FAILURE,
      payload: 'error'
    })
  }
}
